import axios from 'axios';

export default function deleteAuthorizationToken(token) {
    delete axios.defaults.headers.common["Authorization"];
}